export class UserFollowListener {
    public static bindToggleClick(button: HTMLButtonElement, onClick: () => Promise<void> | void): void {
        button.addEventListener("click", () => {
            void onClick();
        });
    }
}
